import { createStore } from "../../tutor/store/createStore";

interface NotepadPerSlideState {
  flags: Record<number, boolean>;
  initFromEnsureSession: (data: Record<number, boolean>) => void;
  markSlideUsed: (slideIndex: number) => void;
  syncSlide: (slideIndex: number, used: boolean) => void;
  clearSlide: (slideIndex: number) => void;
  clear: () => void;
}

const base = (set: any, _get: any): NotepadPerSlideState => ({
  flags: {},

  initFromEnsureSession: (data) => {
    const flags: Record<number, boolean> = {};
    for (const [key, val] of Object.entries(data)) {
      if (val === true) flags[Number(key)] = true;
    }
    set({ flags });
  },

  markSlideUsed: (slideIndex) => {
    set((prev: NotepadPerSlideState) => {
      if (prev.flags[slideIndex] === true) return prev;
      return { flags: { ...prev.flags, [slideIndex]: true } };
    });
  },

  syncSlide: (slideIndex, used) => {
    set((prev: NotepadPerSlideState) => {
      if (used) {
        if (prev.flags[slideIndex] === true) return prev;
        return { flags: { ...prev.flags, [slideIndex]: true } };
      }
      if (prev.flags[slideIndex] === undefined) return prev;
      const updated = { ...prev.flags };
      delete updated[slideIndex];
      return { flags: updated };
    });
  },

  clearSlide: (slideIndex) => {
    set((prev: NotepadPerSlideState) => {
      if (prev.flags[slideIndex] === undefined) return prev;
      const updated = { ...prev.flags };
      delete updated[slideIndex];
      return { flags: updated };
    });
  },

  clear: () => set({ flags: {} }),
});

export const useNotepadPerSlideStore = createStore("NotepadPerSlideStore", base);
